export const salesData = [
    {
        id: 1,
        dateRange: "Today",
        totalSales: "$5,000",
        salesGrowth: "5%",
        avgOrderValue: "$75",
        conversionRate: "3%",
    },
    {
        id: 2,
        dateRange: "This Week",
        totalSales: "$50,000",
        salesGrowth: "5%",
        avgOrderValue: "$75",
        conversionRate: "3%",
    },
    {
        id: 3,
        dateRange: "Last Week",
        totalSales: "$45,000",
        salesGrowth: "5%",
        avgOrderValue: "$75",
        conversionRate: "3%",
    },
    {
        id: 4,
        dateRange: "This Month",
        totalSales: "$100,000",
        salesGrowth: "5%",
        avgOrderValue: "$75",
        conversionRate: "3%",
    },
    {
        id: 5,
        dateRange: "Last Month",
        totalSales: "$80,000",
        salesGrowth: "5%",
        avgOrderValue: "$75",
        conversionRate: "3%",
    },
];

export const salesColumns = [
    {
        name: "Date Range",
        selector: (row) => row.dateRange,
    },
    {
        name: "Total Sales",
        selector: (row) => row.totalSales,
    },
    {
        name: "Sales Growth",
        selector: (row) => row.salesGrowth,
    },
    {
        name: "Average Order Value",
        selector: (row) => row.avgOrderValue,
    },
    {
        name: "Conversion Rate",
        selector: (row) => row.conversionRate,
    },
];

export const customStyles = {
    header: {
        style: {
            fontSize: '15px',
            padding: '0',
            fontWeight: '400',
        },
    },
    headRow: {
        style: {
            backgroundColor: '#F2F2F2',
            borderBottom: 'none',
        },
    },
    headCells: {
        style: {
            paddingLeft: "20px",
            paddingRight: "20px",
            fontSize: '15px',
            fontWeight: 600,
        },
    },
    cells: {
        style: {
            fontSize: '15px',
            padding: '16px 20px',
        },
    },
};

export const inventoryData = [
    {
        id: 1,
        sku: "001",
        productName: "Blue Headphones",
        stock: "200",
        reorderValue: "60",
        inventory: "30",
    },
    {
        id: 2,
        sku: "001",
        productName: "Blue Headphones",
        stock: "200",
        reorderValue: "60",
        inventory: "30",
    },
    {
        id: 3,
        sku: "001",
        productName: "Blue Headphones",
        stock: "200",
        reorderValue: "60",
        inventory: "30",
    },
    {
        id: 4,
        sku: "001",
        productName: "Blue Headphones",
        stock: "200",
        reorderValue: "60",
        inventory: "30",
    },
    {
        id: 5,
        sku: "001",
        productName: "Blue Headphones",
        stock: "200",
        reorderValue: "60",
        inventory: "30",
    },
];

export const inventoryColumns = [
    {
        name: "SKU",
        selector: (row) => row.sku,
    },
    {
        name: "Product name",
        selector: (row) => row.productName,
    },
    {
        name: "Current Stock",
        selector: (row) => row.stock,
    },
    {
        name: "Reorder Value",
        selector: (row) => row.reorderValue,
    },
    {
        name: "Days of Inventory",
        selector: (row) => row.inventory,
    },
];

export const metricsData = [
    {
        id: 1,
        metric: "New Customers",
        value: "500",
        change: "10%",
    },
    {
        id: 2,
        metric: "Returning Customers",
        value: "500",
        change: "10%",
    },
    {
        id: 3,
        metric: "Average Customer Spend",
        value: "$100",
        change: "3%",
    },
    {
        id: 4,
        metric: "Customer Satisfaction",
        value: "4.9/5.0",
        change: "-",
    },
];

export const metricsColumns = [
    {
        name: "Metric",
        selector: (row) => row.metric,
    },
    {
        name: "Value",
        selector: (row) => row.value,
    },
    {
        name: "Change",
        selector: (row) => row.change,
    },
];

export const shippingData = [
    {
        id: 1,
        metric: "Orders Shipped",
        value: "1000",
        target: "-",
    },
    {
        id: 2,
        metric: "Average Shipping Time (days)",
        value: "2",
        target: "1",
    },
    {
        id: 3,
        metric: "On-Time Delivery Rate (%)",
        value: "95%",
        target: "99%",
    },
    {
        id: 4,
        metric: "Return Rate (%)",
        value: "2%",
        target: "1%",
    },
];

export const shippingColumns = [
    {
        name: "Metric",
        selector: (row) => row.metric,
        width: '300px',
    },
    {
        name: "Value",
        selector: (row) => row.value,
    },
    {
        name: "Target",
        selector: (row) => row.target,
    },
];

export const financialData = [
    {
        id: 1,
        revenue: "$200,000",
        cogs: "$100,000",
        expenses: "$20,000",
        profit: "$80,000",
    },
];

export const financialColumns = [
    {
        name: "Revenue",
        selector: (row) => row.revenue,
        width: '300px',
    },
    {
        name: "COGS",
        selector: (row) => row.cogs,
    },
    {
        name: "Operating Expenses",
        selector: (row) => row.expenses,
    },
    {
        name: "Net Profit",
        selector: (row) => row.profit,
    },
];
